import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    numeric
} from "vuelidate/lib/validators";
import $ from "jquery";
import axios from "axios";

export default {
    name: "JobDetailStatus",
    components: {
        MainLayout
    },

    data() {
        return {
            apply: {
                status: "",
                amount: "",
                job_id: ""
            },
            submitted: false
        }
    },

    validations: {
        apply: {
            status: {
                required
            },
            amount: {
                numeric
            }
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.updateStatus();
        },

        getApplyStatus() {
            axios.get("admin/apply/status/" + this.$route.params.id)
                .then(response => {
                    this.apply = response.data;
                })
                .catch(error => {
                    console.log("Apply Status API Error", error);
                });
        },

        updateStatus() {
            var request = {
                id: this.$route.params.id,
                status: this.apply.status,
                amount: this.apply.amount
            };
            axios.post("/admin/apply/status/updated", request)
                .then(() => {
                    this.$notification.success("Apply Status Edited Successfully", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$router.push({
                        path: "/admin/job/detail/" + this.apply.job_id
                    });
                })
                .catch(error => {
                    this.$notification.error("Apply Status Edit Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Edit Apply Status Error", error);
                });
        }
    },

    mounted() {
        this.getApplyStatus();

        $("#amount").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });
    }
};